import { useParams } from "react-router";
import $api from "./openapi";

export default function useGetTimeCostPreset() {
  const { teamSlug } = useParams();

  const { data } = $api.useQuery(
    "get",
    "/api/teams/{team_slug}/time_cost_preset",
    {
      params: {
        path: {
          team_slug: teamSlug!,
        },
      },
    },
    {
      enabled: !!teamSlug,
    },
  );

  return data;
}
